import type { Theme } from '@mui/material/styles/createTheme'
import { css, styled } from '@mui/material'
import MuiIconButton from '@mui/material/IconButton'
import { IconButtonProps } from './IconButton.types'

type CssProps = IconButtonProps & { theme?: Theme }

const variantStyles = ({
  theme,
  variant = 'text',
  color = 'primary',
}: Pick<CssProps, 'theme' | 'variant' | 'color'>) => {
  switch (variant) {
    case 'contained':
      return css`
        color: ${theme?.palette.common.white};
        background-color: ${theme?.palette[color].main};

        &:hover {
          background-color: ${theme?.palette[color].refer?.[600]};
        }
      `
    case 'outlined':
      return css`
        color: ${theme?.palette[color].main};
        background-color: ${theme?.palette.common.white};
        border: 1px solid ${theme?.palette[color].main};

        &:hover {
          background-color: ${theme?.palette.common.white}0D;
        }
      `
    case 'text':
    default:
      return css`
        color: ${theme?.palette[color].main};
        &:hover {
          background-color: ${theme?.palette[color].main}0D;
        }
      `
  }
}

export const IconButton = styled(MuiIconButton)`
  ${variantStyles};
`
